// extracted by mini-css-extract-plugin
module.exports = {"descriptiveHighlightTitle":"DescriptiveHighlightTile_descriptiveHighlightTitle__eykXV","descriptiveHighlightIcon":"DescriptiveHighlightTile_descriptiveHighlightIcon__4JkMz"};